
import { Expose, Type } from 'class-transformer';
import { TaskStatus } from './task-status';

export class Recording {

    @Expose({ name: 'recording_id' })
    recordingId: number;

    @Expose()
    name: string;

    @Expose({ name: 'side_number' })
    sideNumber: string;

    @Expose({ name: 'recorder_id' })
    recorderId: number;

    @Expose({ name: 'disk_space_usage' })
    diskSpaceUsage: number;

    @Expose({ name: 'left_to_download_size' })
    leftToDownloadSize: number;

    @Expose({ name: 'start_date' })
    @Type(() => Date)
    startTime: Date;

    @Expose({ name: 'end_date' })
    @Type(() => Date)
    endTime: Date;

    @Expose()
    status: TaskStatus;

    @Expose({ name: 'data_path' })
    dataPath: string;

}
